import * as i0 from '@angular/core';
import { Injectable, Optional, Inject, Directive, Input, HostListener, ElementRef, Component, ViewChildren, APP_INITIALIZER, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import * as i4 from '@angular/material/button';
import { MatButton, MatButtonModule } from '@angular/material/button';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

class EnvironmentService {
    constructor(config) {
        this.config = config;
        this.objectkey = 'angular_config';
        this.loaded = false;
        this.environmentLocal = {};
        this.objectkey = this.config.windowconfigobjectkey ?? 'angular_config';
        this.objectEnvironment = this.config.environment ?? null;
        if (!window[this.objectkey] && !this.config.environment) {
            return;
        }
        this.loadConfig().then((environmentLocal) => {
            //  console.log('environmentLocal', environmentLocal);
        });
    }
    /** load this in base module */
    loadConfig() {
        return new Promise((resolve, reject) => {
            if (this.environmentLocal && Object.keys(this.environmentLocal).length > 0) {
                resolve(this.environmentLocal);
            }
            else {
                if (this.objectEnvironment) {
                    this.environmentLocal = this.objectEnvironment;
                }
                if (this.objectkey) {
                    const windowConfigs = window[this.objectkey];
                    // merge object in environmentLocal
                    if (windowConfigs && typeof windowConfigs === 'object' && Object.keys(windowConfigs).length > 0) {
                        this.environmentLocal = { ...this.environmentLocal, ...window[this.objectkey] };
                    }
                }
                if (this.environmentLocal) {
                    resolve(this.environmentLocal);
                }
                else {
                    this.loaded = false;
                    reject('no config to load');
                }
            }
            this.loaded = true;
        });
    }
    getEnvironmentConfig(key, defaultValue) {
        if (!this.loaded) {
            this.loadConfig().then((environmentLocal) => {
                return this._getEnvironmentConfig(environmentLocal, key, defaultValue);
            }).catch((error) => {
                console.error('error loading config', error);
            });
        }
        return this._getEnvironmentConfig(this.environmentLocal, key, defaultValue);
    }
    _getEnvironmentConfig(environmentLocal, key, defaultValue) {
        if (!environmentLocal || !environmentLocal[key]) {
            return defaultValue || null;
        }
        const configValue = environmentLocal[key];
        let value;
        if (configValue == 'true') {
            value = Boolean(true);
        }
        else if (configValue == 'false') {
            value = Boolean(false);
        }
        else {
            value = configValue;
        }
        // environmentLocal[key] = value;
        return value;
    }
    getWindowConfig(key, defaultValue) {
        if (!window[this.objectkey] || !window[this.objectkey][key]) {
            return defaultValue || null;
        }
        const configValue = window[this.objectkey][key];
        let value;
        if (configValue == 'true') {
            value = Boolean(true);
        }
        else if (configValue == 'false') {
            value = Boolean(false);
        }
        else {
            value = configValue;
        }
        // window.angular_config[key] = value;
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EnvironmentService, deps: [{ token: 'MARECOMMONCONFIG', optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EnvironmentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EnvironmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['MARECOMMONCONFIG']
                }] }]; } });

class NgxMareCommonService {
    constructor(config, environmentService) {
        this.config = config;
        this.environmentService = environmentService;
        this.isInit = false;
        this.init();
    }
    init() {
        if (!this.isInit) {
            console.log('NgxMareCommonService', this.config);
            if (this.config?.isLoggingEnabled != undefined && !this.config.isLoggingEnabled) {
                window.isLoggingEnabled = this.config?.isLoggingEnabled;
                console.log('NgxMareCommonService disable console.log');
                window.console._log = window.console.log;
                window.console.log = function () { };
                console.log('NgxMareCommonService console.log disabled');
                window.console._log('_log NgxMareCommonService console.log disabled');
            }
        }
        this.isInit = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxMareCommonService, deps: [{ token: 'MARECOMMONCONFIG', optional: true }, { token: EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxMareCommonService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxMareCommonService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['MARECOMMONCONFIG']
                }] }, { type: EnvironmentService }]; } });

class EventInteractionService {
    constructor(config) {
        this.config = config;
        this.fooSubject = new Subject();
        this.isWp = config?.isWp ?? false;
        this.isRouterEnabled = config?.isRouterEnabled ?? false;
    }
    publishData(data) {
        this.fooSubject.next(data);
    }
    getObservable() {
        return this.fooSubject;
    }
    gotoLink(url, newtab) {
        if (this.isRouterEnabled) {
            this.publishData({ event: 'gotoLink', data: { url: url, newtab: newtab } });
        }
        else {
            if (!newtab) {
                this.publishData({ event: 'showLoader', data: {} });
                window.location.href = url;
            }
            else {
                window.open(url, "_blank");
            }
        }
    }
    sendWindowEvent(event, data, bubbles, composed) {
        if (bubbles == undefined || bubbles == null) {
            bubbles = true;
        }
        if (composed == undefined || composed == null) {
            composed = true;
        }
        window.dispatchEvent(new CustomEvent(event, {
            detail: data,
            bubbles,
            composed
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventInteractionService, deps: [{ token: 'MARECOMMONCONFIG', optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventInteractionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventInteractionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['MARECOMMONCONFIG']
                }] }]; } });

class ErrorHandlerService {
    constructor(eventInteractionService) {
        this.eventInteractionService = eventInteractionService;
        this.checkContinousError = false;
    }
    handleError(err) {
        if (this.checkAuthError(err)) {
            this.handleAuthError(err);
        }
        else {
            this.handleServerError(err);
        }
    }
    checkAuthError(err) {
        return (err.status === 401) || (err.status === 403);
    }
    handleAuthError(err) {
        let redirect = this.checkMustRedirect();
        if (err.status === 401) {
            // this.tokenService.deleteToken();
            // this.accountService.deleteAccount()
            this.eventInteractionService.publishData({ event: 'userService_removeCurrentTenant' });
            if (redirect)
                this.navigateToUrl('/');
        }
        else {
            if (redirect)
                this.navigateToUrl('/');
        }
        if (err && err.error && err.error.errors) {
            this.newError(err.error.errors.mainMessage || err.error.errors.message);
        }
        else {
            // this.newError(err.message);
        }
    }
    navigateToUrl(url) {
        window.location.href = url;
    }
    checkMustRedirect() {
        return false;
    }
    handleServerError(err) {
        let mex = null;
        if (err.error) {
            mex = (err.error.message || err.error.mainMessage);
        }
        if (!mex && err.error.errors) {
            mex = err.error.errors.mainMessage;
        }
        // if (!mex && err.message) {
        //   console.error(err.message)
        // }
        //let newError = "error mex:"+mex;
        // TODO: ho commentato il newError perchè faceva aprire lo snack ma è stato commentato
        //this.newError(mex);
        // return throwError(() => {new Error(mex)});
    }
    newError(mex) {
        // console.log("eroore di connesione" , mex);
        // SE MEX non è definito molto probabilmente è un errore di rete gateway timeout in questo caso 
        // evito che venga ripetutto in continuazione e viene mostrato ogni 15 secondi, mentre se il messaggio è presente vuol dire che 
        // il serer a risposto correttamente ad una operazione pertanto restituisce l'errore ogni volta che si presenta
        if (mex == undefined || mex == null || (typeof mex == 'string' && mex.trim() == '')) {
            // HO INTRODOTTO QUESTO WORKAROUND PER EVIATRE CHE SUL POLLING DELLE RICHIESTE INVIASSE CONTINUAMENTE SEGLAZIONE DI ERRORE
            // NEL CASO DI BREVE CADUTO DI LINEA AD ESMEPIO é MOLTO FASTIDIOSO LA SEGNALAZIONE OGNI SECONDO
            if (!this.checkContinousError) {
                let msg = `Si è verificato un errore di rete o di connessione.`;
                if (mex) {
                    msg = mex;
                }
                this.checkContinousError = true;
                clearTimeout(this.checkErroreTimeout);
                this.checkErroreTimeout = undefined;
                // return this.snackBar.open(msg, '', {
                //   duration: 3000,
                //   panelClass: 'warning',
                // });
                console.log('error handler: ', msg);
                return;
            }
            if (this.checkErroreTimeout == undefined || this.checkErroreTimeout == null) {
                this.checkErroreTimeout = setTimeout(() => {
                    this.checkContinousError = false;
                }, 15000);
            }
        }
        else {
            // return this.snackBar.open(mex, '', {
            //   duration: 3000,
            //   panelClass: 'warning',
            // });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorHandlerService, deps: [{ token: EventInteractionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorHandlerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorHandlerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: EventInteractionService }]; } });

class MatomoRegisterService {
    constructor(scriptUrl, idSite) {
        this.scriptUrl = scriptUrl;
        this.idSite = idSite;
        if (!window._paq) {
            this.appendScript().then(() => {
                this._init();
            }).catch((error) => {
                console.error('Error while appending script to head', error);
            });
        }
        else {
            this._init();
        }
    }
    appendScript() {
        if (!window._paq) {
            window._paq = [];
            window._paq.push(['trackPageView']);
            window._paq.push(['enableLinkTracking']);
        }
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            const baseSrc = this.scriptUrl ?? "//analytics.maredigital.it/";
            // script.src = this.scriptUrl ?? 'https://cdn.jsdelivr.net/gh/GoogleCloudPlatform/stackdriver-errors-js/dist/stackdriver-errors.min.js';
            script.src = baseSrc + "matomo.js";
            script.async = true;
            if (script.readyState) { //IE
                script.onreadystatechange = () => {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        resolve(true);
                    }
                };
            }
            else { //Others
                script.onload = () => {
                    resolve(true);
                };
            }
            script.onerror = (error) => reject(error);
            window._paq.push(['setTrackerUrl', baseSrc + 'matomo.php']);
            window._paq.push(['setSiteId', this.idSite]);
            let el = document.getElementsByTagName('script')[0];
            if (el?.parentNode) {
                el.parentNode.insertBefore(script, el);
            }
            else {
                document.head.appendChild(script);
            }
            console.debug('Appended script to head ' + script.src);
        });
    }
    _init() {
        // console.log('Matomo init')
        this.matomo = window._paq;
    }
    sendEvent(event) {
        this.matomo.push(['trackEvent', event.category, event.action, event.name, event.value]);
    }
}

class EventListenerActions {
}
class UserActionsRegisterService {
    constructor(eventInteractionService, matomoRegisterService) {
        this.eventInteractionService = eventInteractionService;
        this.matomoRegisterService = matomoRegisterService;
        this.eventListener = {};
        this.numRetry = 0;
        this.configured = false;
        this.configure();
    }
    configure() {
        // if (!window.MscActionListener){
        //     if(this.numRetry > 5){
        //         console.error('Attenzione... non sono riuscito a trovare la libreria js MscActionListener')
        //         return;
        //     }
        //     this.numRetry = this.numRetry ? this.numRetry + 1 : 1;
        //     this.configured = true;
        //     setTimeout(() => {
        //         this.configure();
        //     }, 200);
        // } else {
        this.configured = true;
        this.eventInteractionService.getObservable().subscribe((data) => {
            if (this.eventListener[data.event]) {
                const listeners = this.eventListener[data.event];
                let d = JSON.parse(JSON.stringify(data));
                if (listeners) {
                    listeners.forEach((listner) => {
                        this.manageListener(listner, JSON.parse(JSON.stringify(d)));
                    });
                }
                if (window.MscActionListener?.msc_listener_action)
                    window.MscActionListener.msc_listener_action(d.event, d.data);
            }
        });
        // }
    }
    manageListener(listner, originalData) {
        let d = JSON.parse(JSON.stringify(originalData));
        if (listner.eventTransformer)
            d = listner.eventTransformer(d);
        if (listner.sendUserAction && window.MscUserActionListener) {
            let value = null;
            let actionCategory = null;
            if (typeof d.data === 'string') {
                value = d.data;
            }
            else if (typeof d.data === 'object') {
                if (d.data.value) {
                    value = d.data.value;
                }
                else {
                    value = JSON.stringify(d.data);
                }
                if (d.data.actionCategory)
                    actionCategory = d.data.actionCategory;
            }
            if (window.MscUserActionListener.addListener)
                window.MscUserActionListener.addListener(d.event, value, actionCategory);
        }
        if (listner.eventMatomoTransformer) {
            if (listner.eventMatomoUseOriginalData) {
                d = JSON.parse(JSON.stringify(originalData));
            }
            let matomoData = listner.eventMatomoTransformer(d);
            if (matomoData) {
                // window._paq.push(matomoData.data);
                this.matomoRegisterService.sendEvent(matomoData);
            }
        }
        return d;
    }
    registerActionListener(event, eventTransformer, sendUserAction, eventMatomoUseOriginalData, eventMatomoTransformer, eventListenerActionsName) {
        if (!this.eventListener[event]) {
            this.eventListener[event] = [];
        }
        let el = new EventListenerActions();
        if (eventTransformer)
            el.eventTransformer = eventTransformer;
        el.sendUserAction = sendUserAction;
        if (eventMatomoTransformer)
            el.eventMatomoTransformer = eventMatomoTransformer;
        if (eventMatomoUseOriginalData)
            el.eventMatomoUseOriginalData = eventMatomoUseOriginalData;
        else
            el.eventMatomoUseOriginalData = false;
        if (eventListenerActionsName) {
            const found = this.eventListener[event].find((element) => {
                return element.eventListenerActionsName === eventListenerActionsName;
            });
            if (found) {
                console.warn('eventListenerActionsName already exists: ' + eventListenerActionsName);
                return;
            }
        }
        el.eventListenerActionsName = eventListenerActionsName ?? event;
        this.eventListener[event].push(el);
    }
    getActionListeners(event) {
        if (this.eventListener[event]) {
            return this.eventListener[event];
        }
        return null;
    }
    getActionListener(event, eventListenerActionsName) {
        if (this.eventListener[event]) {
            for (const element of this.eventListener[event]) {
                if (element.eventListenerActionsName === eventListenerActionsName)
                    return element;
            }
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserActionsRegisterService, deps: [{ token: EventInteractionService }, { token: MatomoRegisterService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserActionsRegisterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserActionsRegisterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: EventInteractionService }, { type: MatomoRegisterService }]; } });

class MatomoRegisterDirective {
    constructor(eventInteractionService, userActionsRegisterService) {
        this.eventInteractionService = eventInteractionService;
        this.userActionsRegisterService = userActionsRegisterService;
    }
    ngOnInit() {
        if (!this.matomoRegister || !this.matomoTransformerFunction) {
            console.error('matomoRegisterEvent is required');
            return;
        }
        let listeners = this.userActionsRegisterService.getActionListener(this.matomoRegister, this.matomoRegisterName);
        if (!listeners) {
            this.userActionsRegisterService.registerActionListener(this.matomoRegister, undefined, false, this.matomoUseOriginalData, this.matomoTransformerFunction);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MatomoRegisterDirective, deps: [{ token: EventInteractionService }, { token: UserActionsRegisterService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: MatomoRegisterDirective, selector: "[matomoRegister]", inputs: { matomoRegister: "matomoRegister", matomoRegisterName: "matomoRegisterName", matomoUseOriginalData: "matomoUseOriginalData", matomoTransformerFunction: "matomoTransformerFunction" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MatomoRegisterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[matomoRegister]'
                }]
        }], ctorParameters: function () { return [{ type: EventInteractionService }, { type: UserActionsRegisterService }]; }, propDecorators: { matomoRegister: [{
                type: Input
            }], matomoRegisterName: [{
                type: Input
            }], matomoUseOriginalData: [{
                type: Input
            }], matomoTransformerFunction: [{
                type: Input
            }] } });

class UserActionDirective {
    constructor(eventInteractionService, userActionsRegisterService) {
        this.eventInteractionService = eventInteractionService;
        this.userActionsRegisterService = userActionsRegisterService;
    }
    ngOnInit() {
        if (!this.userActionRegister || !this.eventData) {
            console.error('eventName and eventData are required');
            return;
        }
        // this.userActionsRegisterService.registerActionListener(this.eventName, undefined, false, this.matomoTransformerFunction);
        let toRegister = false;
        if (this.eventTransformer) {
            toRegister = true;
        }
        if (this.sendUserAction != undefined) {
            toRegister = true;
        }
        if (toRegister) {
            this.userActionsRegisterService.registerActionListener(this.userActionRegister, this.eventTransformer, this.sendUserAction, this.matomoUseOriginalData, this.matomoTransformerFunction);
        }
    }
    onClick($event) {
        console.info('clicked: ' + $event);
        this.eventInteractionService.publishData({
            event: this.userActionRegister,
            data: this.eventData
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserActionDirective, deps: [{ token: EventInteractionService }, { token: UserActionsRegisterService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: UserActionDirective, selector: "[userActionRegister]", inputs: { userActionRegister: "userActionRegister", eventData: "eventData", eventTransformer: "eventTransformer", sendUserAction: "sendUserAction", matomoUseOriginalData: "matomoUseOriginalData", matomoTransformerFunction: "matomoTransformerFunction" }, host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserActionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[userActionRegister]'
                }]
        }], ctorParameters: function () { return [{ type: EventInteractionService }, { type: UserActionsRegisterService }]; }, propDecorators: { userActionRegister: [{
                type: Input
            }], eventData: [{
                type: Input
            }], eventTransformer: [{
                type: Input
            }], sendUserAction: [{
                type: Input
            }], matomoUseOriginalData: [{
                type: Input
            }], matomoTransformerFunction: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/**
 * Configurazione per la direttiva DispatchEventDirective
 * parametri:
 * event: nome dell'evento
 * eventData: dati da inviare
 * eventTransformer: funzione per trasformare i dati in modo che siano compatibili con la userSendAction
 * sendUserAction: se true invia l'evento all'endpoint di user action
 * matomoTransformerFunction: funzione per trasformare i dati in modo che siano compatibili con l'invio di un evento matomo
 *
 */
class DispatchEventDirectiveConfig {
}
class DispatchEventDirective {
    constructor(eventInteractionService, userActionsRegisterService) {
        this.eventInteractionService = eventInteractionService;
        this.userActionsRegisterService = userActionsRegisterService;
        // console.log('DispatchEventDirective')
    }
    ngOnInit() {
        if (!this.dispatchEvent || !this.dispatchEvent.event ||
            (!this.dispatchEvent.eventData && !this.dispatchEventData)) {
            console.error('eventName and eventData are required');
            return;
        }
        // this.userActionsRegisterService.registerActionListener(this.eventName, undefined, false, this.matomoTransformerFunction);
        let toRegister = false;
        if (this.dispatchEvent.eventTransformer) {
            toRegister = true;
        }
        if (this.dispatchEvent.sendUserAction != undefined) {
            toRegister = true;
        }
        if (toRegister) {
            this.userActionsRegisterService.registerActionListener(this.dispatchEvent.event, this.dispatchEvent.eventTransformer, this.dispatchEvent.sendUserAction, this.dispatchEvent.matomoUseOriginalData, this.dispatchEvent.matomoTransformerFunction, this.dispatchEvent.eventListenerActionsName ?? "DispatchEventDirective_" + this.dispatchEvent.event);
        }
    }
    onClick($event) {
        console.info('clicked: ' + $event);
        this.eventInteractionService.publishData({
            event: this.dispatchEvent.event,
            data: this.dispatchEventData ?? this.dispatchEvent.eventData
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DispatchEventDirective, deps: [{ token: EventInteractionService }, { token: UserActionsRegisterService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: DispatchEventDirective, selector: "[dispatchEvent]", inputs: { dispatchEvent: "dispatchEvent", dispatchEventData: "dispatchEventData", dispatchEventName: "dispatchEventName" }, host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DispatchEventDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dispatchEvent]'
                }]
        }], ctorParameters: function () { return [{ type: EventInteractionService }, { type: UserActionsRegisterService }]; }, propDecorators: { dispatchEvent: [{
                type: Input
            }], dispatchEventData: [{
                type: Input
            }], dispatchEventName: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class NgxDialogConfig {
}
class NgxDialogButton {
    constructor() {
        /**
         * to be defined to switch correct action
         * if not provided an event is dispatched
         **/
        this.actionType = NgxDialogButtonActionTypeENUM.PUBLISHEVENT;
    }
}
var NgxDialogButtonActionTypeENUM;
(function (NgxDialogButtonActionTypeENUM) {
    NgxDialogButtonActionTypeENUM["CLOSE"] = "CLOSE";
    NgxDialogButtonActionTypeENUM["CUSTOM"] = "CUSTOM";
    NgxDialogButtonActionTypeENUM["GOTOLINK"] = "GOTOLINK";
    NgxDialogButtonActionTypeENUM["PUBLISHEVENT"] = "PUBLISHEVENT";
})(NgxDialogButtonActionTypeENUM || (NgxDialogButtonActionTypeENUM = {}));
class NgxDialogButtonActionType {
    static { this.CLOSE = NgxDialogButtonActionTypeENUM.CLOSE; }
    static { this.CUSTOM = NgxDialogButtonActionTypeENUM.CUSTOM; }
    static { this.GOTOLINK = NgxDialogButtonActionTypeENUM.GOTOLINK; }
    static { this.PUBLISHEVENT = NgxDialogButtonActionTypeENUM.PUBLISHEVENT; }
    constructor(value) {
        this.value = value;
        this.value = value || NgxDialogButtonActionTypeENUM.PUBLISHEVENT;
    }
}

class NgxDialogComponent {
    constructor(dialogRef, eventInteractionService, data) {
        this.dialogRef = dialogRef;
        this.eventInteractionService = eventInteractionService;
        this.data = data;
    }
    ngAfterViewInit() {
        if (this.actionButtons) {
            this.dialogRef.afterOpened().subscribe(() => {
                setTimeout(() => {
                    this.actionButtons.last.nativeElement.focus();
                }, 0);
            });
        }
    }
    /**
     *  define close method
     * */
    close() {
        this.dialogRef.close();
    }
    /**
     * define onClick method
     * if is defined an actionType, the method will switch to the 'case' to execute an action or publish an event
     * else a generc event is published
     *
     */
    onClick(e, element) {
        if (element.actionType) {
            switch (element.actionType) {
                case NgxDialogButtonActionType.CUSTOM:
                case 'CUSTOM':
                    if (element.onClick) {
                        element.onClick(e, element);
                    }
                    else {
                        this.eventInteractionService.publishData({ event: 'mareDialogCustomEvent', data: this.data });
                    }
                    break;
                case NgxDialogButtonActionType.GOTOLINK:
                case 'GOTOLINK':
                    if (element.externalLink) {
                        this.eventInteractionService.gotoLink(element.externalLink, true);
                        ;
                    }
                    else if (element.routeLink || element.link) {
                        const link = element.link || element.routeLink;
                        this.eventInteractionService.gotoLink(link, false);
                    }
                    else {
                        console.error('link or routelink is required');
                    }
                    break;
                case NgxDialogButtonActionType.PUBLISHEVENT:
                case 'PUBLISHEVENT':
                    this.eventInteractionService.publishData({ event: 'mareDialogEvent', data: this.data });
                    break;
                case NgxDialogButtonActionType.CLOSE:
                case 'CLOSE':
                    this.close();
                    break;
                default:
                    this.eventInteractionService.publishData({ event: 'mareDialogClose' });
                    break;
            }
        }
        else {
            // this.eventInteractionService.publishData({ event: 'mareDialogClose', data: this.data });
            this.close();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDialogComponent, deps: [{ token: i1.MatDialogRef }, { token: EventInteractionService }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: NgxDialogComponent, isStandalone: true, selector: "ngx-dialog", viewQueries: [{ propertyName: "actionButtons", predicate: MatButton, descendants: true, read: ElementRef }], ngImport: i0, template: "<div class=\"ngx-dialog__header\" [ngClass]=\"data.headerclass\" [class.has-close-icon]=\"!data.buttons\">\n    <button mat-button (click)=\"close()\" class=\"ngx-dialog-close-icon\">&times;</button>\n    <h4 class=\"ngx-dialog__subtitle\" *ngIf=\"data.subtitle\">{{ data.subtitle }}</h4>\n    <h1 mat-dialog-title class=\"ngx-dialog__title\" *ngIf=\"data.title\">{{ data.title }}</h1>\n</div>\n<ng-container *ngIf=\"data.contentArray; else singleContent\">\n    <ng-container *ngFor=\"let content of data.contentArray\">\n        <h1 mat-dialog-title class=\"ngx-dialog__title\" *ngIf=\"content.title\">{{ content.title }}</h1>\n        <div mat-dialog-content *ngIf=\"content\" [innerHTML]=\"content.content\" [ngClass]=\"data.bodyclass\"\n            class=\"ngx-dialog__content\">\n        </div>\n        <div mat-dialog-actions *ngIf=\"content.buttons\" class=\"ngx-dialog__actions\">\n            <ng-container *ngIf=\"content.buttons\">\n                <button mat-flat-button *ngFor=\"let button of content.buttons\" (click)=\"onClick($event, button)\"\n                    [disabled]=\"button.disabled\" [color]=\"button.color\"\n                    [class.mdc-button--outlined.mat-mdc-outlined-button]=\"!button.color\"\n                    [ngClass]=\"'ngx-dialog-action__'+button.actionType\"\n                    [mat-dialog-close]=\"button.actionType !== 'CLOSE' ? data : null\">\n                    {{button.label}}\n                    <mat-icon *ngIf=\"button.icon\">{{button.icon}}</mat-icon>\n                </button>\n            </ng-container>\n        </div>\n    </ng-container>\n</ng-container>\n<ng-template #singleContent>\n    <div mat-dialog-content *ngIf=\"data.content\" [innerHTML]=\"data.content\" [ngClass]=\"data.bodyclass\"\n        class=\"ngx-dialog__content\">\n    </div>\n</ng-template>\n\n<div mat-dialog-actions *ngIf=\"data.buttons\" class=\"ngx-dialog__actions\">\n    <ng-container *ngIf=\"data.buttons\">\n        <button mat-flat-button *ngFor=\"let button of data.buttons\" (click)=\"onClick($event, button)\"\n            [disabled]=\"button.disabled\" [color]=\"button.color\"\n            [class.mdc-button--outlined.mat-mdc-outlined-button]=\"!button.color\"\n            [ngClass]=\"'ngx-dialog-action__'+button.actionType\"\n            [mat-dialog-close]=\"button.actionType !== 'CLOSE' ? data : null\">\n            {{button.label}}\n            <mat-icon *ngIf=\"button.icon\">{{button.icon}}</mat-icon>\n        </button>\n    </ng-container>\n</div>", styles: [".mdc-dialog .ngx-dialog__actions{display:flex;justify-content:space-between;align-items:center}.mdc-dialog .ngx-dialog__subtitle{margin:0;padding:20px 24px 0;font-size:var(--mdc-dialog-head-size, .87rem)}.mdc-dialog .ngx-dialog__title{margin:0;padding:0 24px 4px}.mdc-dialog .ngx-dialog__content{padding-top:4px}.ngx-dialog__actions{display:flex;justify-content:space-between;align-items:center;padding:20px 24px}.ngx-dialog__subtitle{margin:0;padding:20px 24px;font-size:var(--mdc-dialog-head-size, .87rem);color:var(--mdc-dialog-head-color, #ABAEB3)}.ngx-dialog__title{margin:0;padding:0 24px 4px}.ngx-dialog__content{padding-top:4px}.ngx-dialog__header{position:relative}.ngx-dialog__header.has-close-icon{padding-right:24px}.ngx-dialog-close-icon{position:absolute;top:4px;right:4px}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: MatDialogModule }, { kind: "directive", type: i1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "ngmodule", type: MatButtonModule }, { kind: "component", type: i4.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "ngmodule", type: MatIconModule }, { kind: "component", type: i5.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-dialog', standalone: true, imports: [
                        CommonModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatIconModule
                    ], template: "<div class=\"ngx-dialog__header\" [ngClass]=\"data.headerclass\" [class.has-close-icon]=\"!data.buttons\">\n    <button mat-button (click)=\"close()\" class=\"ngx-dialog-close-icon\">&times;</button>\n    <h4 class=\"ngx-dialog__subtitle\" *ngIf=\"data.subtitle\">{{ data.subtitle }}</h4>\n    <h1 mat-dialog-title class=\"ngx-dialog__title\" *ngIf=\"data.title\">{{ data.title }}</h1>\n</div>\n<ng-container *ngIf=\"data.contentArray; else singleContent\">\n    <ng-container *ngFor=\"let content of data.contentArray\">\n        <h1 mat-dialog-title class=\"ngx-dialog__title\" *ngIf=\"content.title\">{{ content.title }}</h1>\n        <div mat-dialog-content *ngIf=\"content\" [innerHTML]=\"content.content\" [ngClass]=\"data.bodyclass\"\n            class=\"ngx-dialog__content\">\n        </div>\n        <div mat-dialog-actions *ngIf=\"content.buttons\" class=\"ngx-dialog__actions\">\n            <ng-container *ngIf=\"content.buttons\">\n                <button mat-flat-button *ngFor=\"let button of content.buttons\" (click)=\"onClick($event, button)\"\n                    [disabled]=\"button.disabled\" [color]=\"button.color\"\n                    [class.mdc-button--outlined.mat-mdc-outlined-button]=\"!button.color\"\n                    [ngClass]=\"'ngx-dialog-action__'+button.actionType\"\n                    [mat-dialog-close]=\"button.actionType !== 'CLOSE' ? data : null\">\n                    {{button.label}}\n                    <mat-icon *ngIf=\"button.icon\">{{button.icon}}</mat-icon>\n                </button>\n            </ng-container>\n        </div>\n    </ng-container>\n</ng-container>\n<ng-template #singleContent>\n    <div mat-dialog-content *ngIf=\"data.content\" [innerHTML]=\"data.content\" [ngClass]=\"data.bodyclass\"\n        class=\"ngx-dialog__content\">\n    </div>\n</ng-template>\n\n<div mat-dialog-actions *ngIf=\"data.buttons\" class=\"ngx-dialog__actions\">\n    <ng-container *ngIf=\"data.buttons\">\n        <button mat-flat-button *ngFor=\"let button of data.buttons\" (click)=\"onClick($event, button)\"\n            [disabled]=\"button.disabled\" [color]=\"button.color\"\n            [class.mdc-button--outlined.mat-mdc-outlined-button]=\"!button.color\"\n            [ngClass]=\"'ngx-dialog-action__'+button.actionType\"\n            [mat-dialog-close]=\"button.actionType !== 'CLOSE' ? data : null\">\n            {{button.label}}\n            <mat-icon *ngIf=\"button.icon\">{{button.icon}}</mat-icon>\n        </button>\n    </ng-container>\n</div>", styles: [".mdc-dialog .ngx-dialog__actions{display:flex;justify-content:space-between;align-items:center}.mdc-dialog .ngx-dialog__subtitle{margin:0;padding:20px 24px 0;font-size:var(--mdc-dialog-head-size, .87rem)}.mdc-dialog .ngx-dialog__title{margin:0;padding:0 24px 4px}.mdc-dialog .ngx-dialog__content{padding-top:4px}.ngx-dialog__actions{display:flex;justify-content:space-between;align-items:center;padding:20px 24px}.ngx-dialog__subtitle{margin:0;padding:20px 24px;font-size:var(--mdc-dialog-head-size, .87rem);color:var(--mdc-dialog-head-color, #ABAEB3)}.ngx-dialog__title{margin:0;padding:0 24px 4px}.ngx-dialog__content{padding-top:4px}.ngx-dialog__header{position:relative}.ngx-dialog__header.has-close-icon{padding-right:24px}.ngx-dialog-close-icon{position:absolute;top:4px;right:4px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: EventInteractionService }, { type: NgxDialogConfig, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { actionButtons: [{
                type: ViewChildren,
                args: [MatButton, { read: ElementRef }]
            }] } });

class DialogInteractionService {
    constructor(dialog, eventInteractionService) {
        this.dialog = dialog;
        this.eventInteractionService = eventInteractionService;
    }
    openDialog(dialogComponentConfig, dialogComponent) {
        console.log('showDialog');
        if (!dialogComponent) {
            dialogComponent = NgxDialogComponent;
        }
        const dialogRef = this.dialog.open(dialogComponent, {
            width: dialogComponentConfig?.width ?? '500px',
            height: dialogComponentConfig?.height ?? 'auto',
            data: dialogComponentConfig,
            panelClass: dialogComponentConfig?.panelclass ?? 'ngx-mare-dialog-container'
        });
        dialogRef.afterClosed().subscribe(result => {
            this.eventInteractionService.publishData({ event: 'mareDialogClose', data: result });
            // console.log'The dialog was closed');
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DialogInteractionService, deps: [{ token: i1.MatDialog }, { token: EventInteractionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DialogInteractionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DialogInteractionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialog }, { type: EventInteractionService }]; } });

class NgxMareCommonModule {
    static forRoot(config = { isLoggingEnabled: true }) {
        return {
            ngModule: NgxMareCommonModule,
            providers: [
                EventInteractionService,
                DialogInteractionService,
                EnvironmentService,
                ErrorHandlerService,
                NgxMareCommonService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: (service) => function () { return service.init(); },
                    deps: [NgxMareCommonService],
                    multi: true
                },
                { provide: 'MARECOMMONCONFIG', useValue: config },
                { provide: MAT_DIALOG_DATA, useValue: {} },
                { provide: MatDialogRef, useValue: {} }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxMareCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NgxMareCommonModule, declarations: [MatomoRegisterDirective,
            UserActionDirective,
            DispatchEventDirective], exports: [MatomoRegisterDirective,
            UserActionDirective,
            DispatchEventDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxMareCommonModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NgxMareCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        MatomoRegisterDirective,
                        UserActionDirective,
                        DispatchEventDirective
                    ],
                    imports: [],
                    exports: [
                        MatomoRegisterDirective,
                        UserActionDirective,
                        DispatchEventDirective
                    ]
                }]
        }] });

/**
 * Questa classe serve per configurare il GlobalErrorHandler
 */
class GlobalErrorHandlerConfig {
    constructor(apiKey, projectId) {
        this.apiKey = apiKey;
        this.projectId = projectId;
    }
}
/**
 * Questa classe serve per configurare il GlobalErrorHandler
 * In particolare attraverso questo servizio c'è la possibilità di registrare gli errori su Stackdriver Error Reporting di Google Cloud Platform
 */
class GlobalErrorHandler {
    constructor(config) {
        this.config = config;
        if (!config.apiKey || !config.projectId) {
            throw new Error('You must provide an API Key and a Project ID to use Stackdriver Error Reporting');
        }
        if (!this.config.scriptVersion) {
            this.config.scriptVersion = '0.12.0';
            console.debug('Set default version to ' + this.config.scriptVersion);
        }
        if (!this.config.sendConfiguration) {
            this.config.sendConfiguration = {
                service: 'Angular App',
                version: '1.0.0',
                reportUncaughtExceptions: true,
                reportUnhandledPromiseRejections: true,
                disabled: false,
                context: {
                    env: 'dev'
                }
            };
        }
        if (!window.StackdriverErrorReporter) {
            this.appendScript().then(() => {
                this._init();
            }).catch((error) => {
                console.error('Error while appending script to head', error);
            });
            return;
        }
        // The event listener bellow will be triggered only on real devices. If you want to use this in a browser, you should change it to window.addEventListener('DOMContentLoaded'...
        document.addEventListener('DOMContentLoaded', () => {
            this._init();
        });
    }
    _init() {
        if (!window.StackdriverErrorReporter) {
            throw new Error('StackdriverErrorReporter is not defined. Did you forget to include the Stackdriver Error Reporting library?');
        }
        this.errorHandler = new window.StackdriverErrorReporter();
        this.errorHandler.start({
            key: this.config.apiKey,
            projectId: this.config.projectId,
            ...this.config.sendConfiguration
        });
    }
    handleError(erro) {
        if (!this.config.preventLog) {
            console.error(erro);
        }
        this.errorHandler?.report(erro);
    }
    appendScript() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            // script.src = this.scriptUrl ?? 'https://cdn.jsdelivr.net/gh/GoogleCloudPlatform/stackdriver-errors-js/dist/stackdriver-errors.min.js';
            script.src = this.config.scriptUrl ?? "https://cdn.jsdelivr.net/npm/stackdriver-errors-js@" + this.config.scriptVersion + "/dist/stackdriver-errors-concat.min.js";
            script.async = true;
            if (script.readyState) { //IE
                script.onreadystatechange = () => {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        resolve(true);
                    }
                };
            }
            else { //Others
                script.onload = () => {
                    resolve(true);
                };
            }
            script.onerror = (error) => reject(error);
            document.head.appendChild(script);
            console.debug('Appended script to head ' + script.src);
        });
    }
}

/*
 * Public API Surface of ngx-mare-common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogInteractionService, DispatchEventDirective, DispatchEventDirectiveConfig, EnvironmentService, ErrorHandlerService, EventInteractionService, EventListenerActions, GlobalErrorHandler, GlobalErrorHandlerConfig, MatomoRegisterDirective, MatomoRegisterService, NgxDialogButton, NgxDialogButtonActionType, NgxDialogButtonActionTypeENUM, NgxDialogComponent, NgxDialogConfig, NgxMareCommonModule, NgxMareCommonService, UserActionDirective, UserActionsRegisterService };
